var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiplechoiceExamEntrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_63502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.526 29.5699L74.2125 29.5709L74.2048 44.9347L126.536 44.9417L126.526 29.5699Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7845 81.0536L65.0796 81.0552L65.0817 97.3243L80.7866 97.3227L80.7845 81.0536Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.215 49.5491L119.953 99.3198L123.708 103.681L181.962 53.9279L178.215 49.5491Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.156 64.5935L132.885 114.339L129.13 109.977L187.384 60.2239L191.156 64.5935Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.629 45.1842L180.481 52.1835L189.11 62.2075L197.241 55.2002L188.629 45.1842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.005 25.3407C104.976 24.5413 104.712 23.7681 104.247 23.1175C103.782 22.4668 103.135 21.9675 102.388 21.6816C101.641 21.3957 100.826 21.3359 100.046 21.5097C99.2647 21.6834 98.5523 22.0831 97.9969 22.6588C97.4416 23.2345 97.0679 23.9609 96.9224 24.7475C96.7769 25.534 96.866 26.346 97.1786 27.0823C97.4912 27.8186 98.0135 28.4467 98.6805 28.8883C99.3475 29.3299 100.13 29.5655 100.93 29.5658C101.475 29.5565 102.013 29.4398 102.513 29.2223C103.013 29.0049 103.465 28.6909 103.844 28.2985C104.222 27.906 104.52 27.4428 104.719 26.9352C104.918 26.4277 105.015 25.8858 105.005 25.3407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.328 117.544L113.22 118.407L114.622 114.408L117.328 117.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.211 123.923L179.206 135.309",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.908 129.631L173.512 129.601",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.858 193.914C79.7704 194.329 79.5614 194.709 79.2576 195.005C78.9538 195.301 78.569 195.5 78.1518 195.577C77.8402 195.635 77.5198 195.622 77.2135 195.541C76.9073 195.46 76.6228 195.312 76.3804 195.108C76.1379 194.904 75.9436 194.649 75.8114 194.361C75.6791 194.073 75.6121 193.759 75.6152 193.443C75.6204 193.144 75.6878 192.85 75.8132 192.58C75.9385 192.309 76.1189 192.067 76.343 191.87C76.5671 191.673 76.8298 191.525 77.1144 191.435C77.399 191.346 77.6991 191.316 77.9957 191.349C78.2922 191.382 78.5786 191.477 78.8366 191.627C79.0945 191.777 79.3183 191.979 79.4936 192.22C79.6689 192.462 79.7918 192.737 79.8546 193.029C79.9173 193.321 79.9185 193.622 79.858 193.914Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.457 16.8516C142.392 17.1566 142.238 17.4354 142.014 17.6526C141.791 17.8699 141.507 18.0158 141.201 18.0719C140.972 18.1144 140.736 18.1056 140.511 18.0459C140.285 17.9862 140.076 17.8772 139.898 17.7268C139.72 17.5763 139.578 17.3882 139.482 17.1761C139.385 16.9639 139.337 16.733 139.341 16.5C139.344 16.267 139.399 16.0375 139.501 15.8282C139.604 15.6189 139.751 15.435 139.933 15.2897C140.115 15.1444 140.328 15.0413 140.554 14.988C140.781 14.9347 141.017 14.9324 141.245 14.9813C141.652 15.0719 142.007 15.3187 142.233 15.6685C142.46 16.0184 142.54 16.4433 142.457 16.8516Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.542 37.2574L148.52 37.2554L148.514 74.9132",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.517 100.997L148.504 169.681L52.2173 169.679L52.2151 37.2447L74.2107 37.2508",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.536 44.9388L74.2053 44.9317L74.213 29.568L126.527 29.567L126.536 44.9388Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.007 25.3405C104.98 26.1406 104.717 26.9151 104.253 27.5672C103.789 28.2194 103.143 28.7204 102.395 29.0079C101.648 29.2953 100.833 29.3564 100.051 29.1836C99.2693 29.0108 98.5557 28.6117 97.9993 28.036C97.4429 27.4604 97.0683 26.7337 96.9221 25.9465C96.7759 25.1594 96.8647 24.3466 97.1773 23.6096C97.49 22.8725 98.0127 22.2438 98.6803 21.8019C99.3478 21.3599 100.131 21.1242 100.931 21.1243C102.031 21.1431 103.078 21.5979 103.842 22.3885C104.606 23.1792 105.025 24.241 105.007 25.3405Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.663 68.7946L65.0838 68.7817L65.0764 52.8636L135.664 52.8592L135.663 68.7946Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7823 97.3215L65.0766 97.3227L65.0852 81.0542L80.791 81.053L80.7823 97.3215Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.662 85.9074L122.266 97.3431L94.1247 97.3339L94.1161 81.0574L135.657 81.0425L135.662 85.9074Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7885 125.702L65.0845 125.704L65.083 109.41L80.7807 109.426L80.7894 125.703L80.7885 125.702Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.646 111.983L135.645 125.708L94.1205 125.688L94.1291 109.42L116.381 109.419",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7757 154.075L65.0789 154.06L65.0698 137.782L80.7929 137.789L80.7757 154.075Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.658 154.069L94.1248 154.068L94.1166 137.79L135.649 137.792L135.658 154.069Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5962 83.0513L72.9292 94.1645L83.2712 80.2943",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2703 106.881L62.5917 128.245",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.23 128.273L62.6306 106.856",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2679 135.236L62.5888 156.602",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2442 156.636L62.6279 135.211",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.155 64.5908L132.885 114.336L119.954 99.3169L178.215 49.5461L191.155 64.5908Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.242 55.1993L189.111 62.2066L180.481 52.1825L188.63 45.1833L197.242 55.1993Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.886 114.337L113.221 118.407L119.955 99.3174",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.622 114.408L117.328 117.544",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.969 53.9094L123.708 103.68",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.384 60.221L129.131 109.974",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6435 149.055C19.6409 147.707 20.1432 146.72 21.7885 144.456C25.2921 139.635 23.0725 136.341 20.0115 136.259C19.5213 136.243 19.0329 136.324 18.5742 136.498C18.1156 136.671 17.6959 136.934 17.3393 137.271C16.9827 137.607 16.6962 138.011 16.4965 138.459C16.2967 138.907 16.1876 139.39 16.1755 139.88C16.1706 140.114 16.1887 140.349 16.2287 140.579",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7894 153.549C20.7914 153.689 20.7658 153.829 20.7139 153.959C20.662 154.09 20.5848 154.209 20.4869 154.31C20.3889 154.411 20.2721 154.491 20.143 154.547C20.0139 154.603 19.8751 154.632 19.7346 154.634C19.594 154.636 19.4545 154.611 19.3238 154.559C19.1932 154.507 19.0741 154.43 18.9732 154.332C18.8724 154.234 18.7919 154.117 18.7362 153.988C18.6805 153.859 18.6508 153.72 18.6488 153.58C18.6447 153.296 18.7535 153.022 18.9513 152.818C19.1491 152.615 19.4197 152.498 19.7036 152.494C19.9875 152.49 20.2613 152.599 20.465 152.796C20.6686 152.994 20.7853 153.265 20.7894 153.549Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 29.5C15 33.374 15.763 37.2101 17.2456 40.7892C18.7281 44.3683 20.901 47.6203 23.6403 50.3596C26.3797 53.099 29.6317 55.2719 33.2108 56.7544C36.7899 58.237 40.626 59 44.5 59L44.5 29.5L15 29.5Z",
    fill: "#90B1FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5268,
    cy: 29.5546,
    r: 25.2411,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5061 35.604C47.8466 35.604 50.5547 32.8953 50.5547 29.554C50.5547 26.2126 47.8466 23.5039 44.5061 23.5039C41.1656 23.5039 38.4575 26.2126 38.4575 29.554C38.4575 32.8953 41.1656 35.604 44.5061 35.604Z",
    fill: "#90B1FB",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5064 33.5924C46.7362 33.5924 48.5438 31.7843 48.5438 29.554C48.5438 27.3237 46.7362 25.5156 44.5064 25.5156C42.2766 25.5156 40.469 27.3237 40.469 29.554C40.469 31.7843 42.2766 33.5924 44.5064 33.5924Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5059 39.6427C50.0762 39.6427 54.5918 35.1259 54.5918 29.5543C54.5918 23.9826 50.0762 19.4658 44.5059 19.4658C38.9356 19.4658 34.4199 23.9826 34.4199 29.5543C34.4199 35.1259 38.9356 39.6427 44.5059 39.6427Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5061 45.693C53.417 45.693 60.6406 38.4676 60.6406 29.5545C60.6406 20.6415 53.417 13.416 44.5061 13.416C35.5953 13.416 28.3716 20.6415 28.3716 29.5545C28.3716 38.4676 35.5953 45.693 44.5061 45.693Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6986 29.5537H23.3286",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5061 50.7369V8.35645",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5513 29.5088L51.6054 36.7298",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6239 29.5546C57.6239 22.3035 51.7554 16.4336 44.5061 16.4336",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_63502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201.834,
    height: 201.834,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplechoiceExamEntrance);
export default __webpack_public_path__ + "static/media/multiplechoice_exam_entrance.d5f4906612fa3e11fbb6005dceb1bf51.svg";
export { ForwardRef as ReactComponent };